import { render, staticRenderFns } from "./OfficialFee.vue?vue&type=template&id=730675ee&"
import script from "./OfficialFee.vue?vue&type=script&lang=js&"
export * from "./OfficialFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports